(() => {
  const init = scope => scope.querySelectorAll('[data-serum-reviews]').forEach(section => {
    if (section.dataset.reviewsInitialized) return;
    section.dataset.reviewsInitialized = 'true';
    const reviews = [...section.querySelectorAll('[data-review-item]')];
    const photos = reviews.filter(review => review.querySelector('[data-review-full-photo]'));
    const perPage = Math.max(1, Number(section.dataset.perPage) || 5);
    const pages = Math.ceil(reviews.length / perPage);
    const nav = section.querySelector('[data-review-pagination]');
    const status = section.querySelector('[data-review-status]');
    const dialog = section.querySelector('[data-review-dialog]');
    let page = 1, photoIndex = 0, opener, priorOverflow;
    function showPage(next, scroll = false) {
      page = Math.max(1, Math.min(pages, next));
      reviews.forEach((review, index) => { review.hidden = index < (page - 1) * perPage || index >= page * perPage; });
      nav.replaceChildren();
      const add = (text, target, label, disabled = false, current = false) => {
        const button = document.createElement('button');
        button.type = 'button'; button.textContent = text;
        button.dataset.reviewPage = target; button.setAttribute('aria-label', label);
        button.disabled = disabled;
        if (current) button.setAttribute('aria-current', 'page');
        nav.append(button);
      };
      add('‹', page - 1, 'Previous page', page === 1);
      for (let p = 1; p <= pages; p++) add(String(p), p, `Page ${p}`, false, p === page);
      add('›', page + 1, 'Next page', page === pages);
      nav.hidden = pages < 2;
      status.textContent = `Page ${page} of ${pages}`;
      if (scroll) section.querySelector('[data-review-list]').scrollIntoView({behavior:'smooth',block:'start'});
    }
    function showPhoto(index) {
      photoIndex = (index + photos.length) % photos.length;
      const review = photos[photoIndex];
      const text = selector => review.querySelector(selector)?.textContent.trim() || '';
      const image = dialog.querySelector('[data-modal-photo]');
      image.src = review.querySelector('[data-review-full-photo]').dataset.reviewFullPhoto;
      image.alt = `Customer photo from ${text('.author')}`;
      dialog.querySelector('[data-modal-author]').textContent = text('.author');
      dialog.querySelector('[data-modal-title]').textContent = text('.stamped-review-header-title');
      dialog.querySelector('[data-modal-body]').textContent = text('.stamped-review-content-body');
      dialog.querySelector('[data-modal-date]').textContent = text('.created');
      dialog.querySelector('[data-modal-rating]').textContent = '★'.repeat(Number(review.dataset.rating) || 5);
      dialog.querySelector('[data-modal-verified]').hidden = review.dataset.verified !== 'buyer';
      const votes = review.querySelector('.stamped-review-vote');
      dialog.querySelector('[data-modal-votes]').replaceChildren(...(votes ? [votes.cloneNode(true)] : []));
      dialog.querySelectorAll('[data-review-modal-prev],[data-review-modal-next]').forEach(button => button.hidden = photos.length < 2);
      dialog.scrollTop = 0;
    }
    section.addEventListener('click', async event => {
      const open = event.target.closest('[data-review-open]');
      if (open) {
        event.preventDefault();
        const index = photos.findIndex(review => review.id === open.dataset.reviewOpen);
        if (index < 0) return;
        opener = open; showPhoto(index);
        if (!dialog.open) {
          priorOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          dialog.showModal();
        }
        return;
      }
      const pagination = event.target.closest('[data-review-page]');
      if (pagination) { showPage(Number(pagination.dataset.reviewPage), true); return; }
      if (event.target.closest('[data-review-close]')) dialog.close();
      if (event.target.closest('[data-review-modal-prev]')) showPhoto(photoIndex - 1);
      if (event.target.closest('[data-review-modal-next]')) showPhoto(photoIndex + 1);
      const share = event.target.closest('[data-review-share]');
      if (share) {
        const review = share.closest('[data-review-item]');
        const url = new URL(section.querySelector('[data-review-product]').href); url.hash = review.id;
        try {
          if (navigator.share) await navigator.share({title:review.querySelector('h3').textContent,url:url.href});
          else { await navigator.clipboard.writeText(url.href); status.textContent = 'Review link copied'; }
        } catch (error) { if (error.name !== 'AbortError') status.textContent = 'Unable to share this review'; }
      }
    });
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => { document.documentElement.style.overflow = priorOverflow || ''; opener?.focus({preventScroll:true}); });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); showPhoto(photoIndex + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    showPage(1);
    const hashReview = reviews.find(review => `#${review.id}` === location.hash);
    if (hashReview) showPage(Math.floor(reviews.indexOf(hashReview) / perPage) + 1);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelector('[data-review-dialog][open]')?.close());
})();
